import type { TransactionPredicate } from './types';

export const hasAdditionalTextSymbols: TransactionPredicate = ({ additionalTexts }) =>
    Boolean(
        additionalTexts?.constantSymbol ||
            additionalTexts?.variableSymbol ||
            additionalTexts?.specificSymbol,
    );
